import PropTypes from 'prop-types';
import React from 'react';
import { LinkedAdjustmentLinkIcon } from '../LinkedAdjustmentLinkIcon';

const LinkedAdjustmentIconHeader = ({ hasLinks, hasBrokenLinks, expanded }) => {
  const showLinkIcon = !expanded && hasLinks;

  if (!showLinkIcon) {
    return null;
  }

  return (
    <LinkedAdjustmentLinkIcon interactive={false} isBroken={hasBrokenLinks} />
  );
};

LinkedAdjustmentIconHeader.propTypes = {
  hasLinks: PropTypes.bool.isRequired,
  hasBrokenLinks: PropTypes.bool.isRequired,
  expanded: PropTypes.bool.isRequired,
};

export default LinkedAdjustmentIconHeader;
